module.exports = __webpack_public_path__ + "img/director-school-icon1.c8f17627.jpg";